import { PdChatList } from "./pd-chat/PdChatList.js";
//#region src/pd-chat/pd-chat-list.ts
var tag = "pd-chat-list";
if (!customElements.get(tag)) customElements.define(tag, PdChatList);
//#endregion
export { PdChatList };
